import { Injectable } from '@angular/core';
import {
    Action,
    createSelector,
    Selector,
    State,
    StateContext,
} from '@ngxs/store';
import { GetDealStatuses } from './deal-statuses.actions';
import { DealStatusesService } from 'app/services/deals/deal-statuses.service';
import { catchError, tap } from 'rxjs';
import { DealStatusRecord } from 'app/models/dto/deal-status.model';

export class DealStatusesStateModel {
    dealStatuses: DealStatusRecord[];
}

@State<DealStatusesStateModel>({
    name: 'dealStatuses',
    defaults: {
        dealStatuses: [],
    },
})
@Injectable()
export class DealStatusesState {
    @Selector()
    static dealStatuses(state: DealStatusesStateModel): DealStatusRecord[] {
        return state.dealStatuses;
    }

    /**
     * @param statusString
     * @returns The display name of the given deal status string.
     */
    static displayName(statusString: string) {
        return createSelector(
            [DealStatusesState],
            (state: DealStatusesStateModel) => {
                const dealStatus = state.dealStatuses.find(
                    (status) => status.name === statusString
                );

                if (!dealStatus) {
                    return statusString;
                }

                return dealStatus.displayName;
            }
        );
    }

  /**
   * @param statusString
   * @returns The stage the given deal status string belongs to.
   */
  static stageForStatus(statusString: string) {
      return createSelector(
          [DealStatusesState],
          (state: DealStatusesStateModel) => {
              const dealStatus = state.dealStatuses.find(
                  (status) => status.name === statusString
              );

              if (!dealStatus) {
                  return '';
              }

              return dealStatus.deal_stage.name;
          }
      );
  }

    constructor(private dealStatusService: DealStatusesService) {}

    @Action(GetDealStatuses)
    getDealStatuses({ patchState }: StateContext<DealStatusesStateModel>) {
        return this.dealStatusService.getDealStatusesWithAliases().pipe(
            catchError((error) => {
                console.error('Error fetching deal statuses:', error);
                throw error;
            }),
            tap((dealStatuses) => patchState({ dealStatuses }))
        );
    }
}
